import { AbstractDTO } from '../abstract';
import { FccConfigDTO } from "./fcc-config";

declare let _: any;

export class FccDTO extends AbstractDTO {
	fieldName: string;
	_value: string;
	fccConfig: FccConfigDTO[];
	tag: string;

    constructor(attributes?: Object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.fieldName = attributes['fieldName'] || '';
        this.value = attributes['value'] || '';
        this.fccConfig = FccConfigDTO.createFromArray(attributes['fccConfig']) || null;
		this.tag = attributes['tag'] || '';
    }

	public getFieldList() {
		return this.fccConfig.filter(fc => fc.sourceFieldName != '').map(fc => fc.sourceFieldName + '_s');
	}

	get value() { return this._value; }
	set value(value: string) {
    	this._value += value;
    }

    resetValue() {
		this._value = '';
	}

	dataToAddToCart(cngData) {

	}
}
